export enum ErrorCheck {
  Dirty = 'dirty',
  Errors = 'errors',
}
